import { render } from "./TokenTrades.vue?vue&type=template&id=2cfa09cd&scoped=true"
import script from "./TokenTrades.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenTrades.vue?vue&type=script&setup=true&lang=js"

import "./TokenTrades.vue?vue&type=style&index=0&id=2cfa09cd&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfa09cd"],['__file',"resources/js/components/TokenTrades.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cfa09cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cfa09cd', __exports__)) {
    api.reload('2cfa09cd', __exports__)
  }
  
  module.hot.accept("./TokenTrades.vue?vue&type=template&id=2cfa09cd&scoped=true", () => {
    api.rerender('2cfa09cd', render)
  })

}


export default __exports__